import { computed } from 'vue';

import { useRulesStore } from '../store/rules';

import { RuleItem } from '../utils/types';
import { fixNumbers } from '../utils/math';

import { useCalculationEngine } from '../composables/useCalculationEngine';
import { useCurrentCalculation } from '../composables/useCurrentCalculation';
import { useCurrentCalculator } from '../composables/useCurrentCalculator';

export function useCurrentEstimatedPdfs() {
  const { evalRules } = useCalculationEngine('-');
  const { currentCalculation } = useCurrentCalculation();
  const { currentCalculator } = useCurrentCalculator();

  const rulesStore = useRulesStore();

  const currentCalculatonSegmentsId = computed(() => {
    return (
      currentCalculation.value?.calculation_segments.map((segment) => segment.segment_id) || []
    );
  });

  function isSelectedSegmentRule(rule: RuleItem) {
    return Boolean(
      rule.ruleable_type === 'segment' &&
        rule.ruleable_id &&
        currentCalculatonSegmentsId.value.includes(rule.ruleable_id)
    );
  }

  function isCurrentCalculatorRule(rule: RuleItem) {
    return Boolean(
      rule.ruleable_type === 'calculator' && rule.ruleable_id === currentCalculator.value?.id
    );
  }

  const pdfsRules = computed(() => {
    if (!rulesStore.data) return [];

    return rulesStore.data
      .filter(
        (rule) =>
          rule.type === 'presentation' &&
          rule.is_visible &&
          rule.parent_id === null &&
          rule.pdf_field_identifier &&
          (isSelectedSegmentRule(rule) || isCurrentCalculatorRule(rule))
      )
      .map((rule) => {
        return {
          ...rule,
          eval:
            rule.unit === '%'
              ? (Number(evalRules(rule.rules)) * 100).toFixed(2)
              : fixNumbers(evalRules(rule.rules)),
        };
      });
  });

  return {
    pdfsRules,
  };
}
